import { Stepper } from "react-form-stepper";

const ScanningProgress = ({ stepNumber, scanSteps, onCancel }) => {
  return (
    <div
      className='d-flex flex-column align-items-center justify-content-center mx-4 my-2 gap-4 p-4 rounded  w-auto '
      style={{
        minWidth: "600px",
        minHeight: "200px",
      }}
    >
      <h2 className='text-center mb-2'>
        <span
          className='spinner-border spinner-border-lg'
          aria-hidden='true'
        ></span>
        <span> Scanning...</span>
      </h2>
      {scanSteps?.length > 0 && stepNumber !== undefined && (
        <Stepper
          steps={scanSteps.map((step) => ({ label: step.name }))}
          activeStep={stepNumber - 1}
          styleConfig={{
            size: "2em",
            labelFontSize: "1em",
            activeBgColor: "#1CA4EE",
            completedBgColor: "#8ED2F7",
            inactiveBgColor: "#808080ff",
            shape: "circle",
            color: "#fff",
          }}
        />
      )}

      {onCancel && (
        <button
          className='btn btn-danger ms-2 w-25 mt-2 text-nowrap'
          type='button'
          onClick={onCancel}
          aria-label='Cancel scan in progress'
        >
          Cancel Scan
        </button>
      )}
    </div>
  );
};
export default ScanningProgress;
